import React, { useContext, useEffect, useState } from 'react';
import styles from '../css/share/share-modal.module.css';
import linkIcon from '../../images/link.svg';
import { ShareLinkContext } from './ShareLinkContext';
import {
    WhatsappShareButton,
    TelegramShareButton,
    FacebookMessengerShareButton,
    EmailShareButton,
    WhatsappIcon,
    TelegramIcon,
    FacebookMessengerIcon,
    EmailIcon
} from 'react-share';
import { getAuth } from 'firebase/auth';
import { useAuthState } from 'react-firebase-hooks/auth';
import RadioButtonGroup from '../RadioButtonGroup';
import { ShareExpirationOptions } from '../../Constants';

function ShareLink({ children, shareType, closeModal }) {
    const auth = getAuth();
    const [user] = useAuthState(auth);
    const firstName = user?.displayName?.split(" ")[0] ?? "";

    const [showFallback, setShowFallback] = useState(false);
    const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
    const [copied, setCopied] = useState(false);
    const { showShareModal, shareMessage, expirationIndex, setExpirationIndex, shareLink } = useContext(ShareLinkContext);

    const sharePhrase = shareType === 'flow' ? 'flow' : 'story';
    useEffect(() => {
        if (navigator.share && isMobile) {
            const combined = `${shareMessage} ${shareLink}`

            navigator.share({
                // url: shareLink,
                // title: `${firstName} shared a ${sharePhrase} with you`,
                text: combined
            }).then(() => {
                // Optional: auto-close after successful share
                closeModal();
            }).catch((err) => {
                // User dismissed or share not supported — show fallback UI
                console.warn('Native share cancelled or failed:', err);
                setShowFallback(true);
            });
        }
        else {
            setShowFallback(true);
        }
    }, [shareLink, isMobile]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(`${shareMessage} ${shareLink}`);
            setCopied(true);
            setTimeout(() => setCopied(false), 5000);
        }
        catch {
            setCopied(false);
        }
    };

    const handleExpiryChange = (index, selection) => {
        setExpirationIndex(index);
    };

    return (
        showShareModal &&
        <div className={`${styles.shareModal}`} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
                <h3 className={styles.shareTitle}>{`Your share link`}</h3>
                <button className={styles.closeButton} onClick={closeModal}>×</button>
            </div>
            <div>
                <div className={styles.copyRow}>
                    <span className={styles.linkIcon}>
                        <img src={linkIcon} width={16} />
                    </span>
                    <input className={styles.linkInput} type="text" value={shareLink} readOnly />
                    <button
                        className={`${styles.copyButton} ${copied ? styles.copied : ''}`}
                        onClick={handleCopy}
                    >
                        {copied ? 'Copied!' : 'Copy'}
                    </button>
                </div>
            </div>
            <div style={{ display: 'flex' }}>
                {showFallback && (
                    <div className={styles.iconsDiv}>
                        <p className={styles.subheading}>Or share with</p>
                        <div className={styles.iconRow}>
                            <WhatsappShareButton url={shareLink} className={styles.iconWrapper}>
                                <WhatsappIcon size={36} round />
                            </WhatsappShareButton>
                            <TelegramShareButton url={shareLink} className={styles.iconWrapper}>
                                <TelegramIcon size={36} round />
                            </TelegramShareButton>
                            <FacebookMessengerShareButton url={shareLink} className={styles.iconWrapper}>
                                <FacebookMessengerIcon size={36} round />
                            </FacebookMessengerShareButton>
                            <EmailShareButton url={shareLink} className={styles.iconWrapper}>
                                <EmailIcon size={36} round />
                            </EmailShareButton>
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.expiryOptions}>
                <p className={styles.subheading} style={{ marginTop: '0.75rem' }}>Link expires in</p>
                <RadioButtonGroup values={ShareExpirationOptions.map(option => option.text)}
                    selection={ShareExpirationOptions[expirationIndex].text} handleChange={handleExpiryChange}
                    customStyles={{ borderColor: 'lightgray', marginTop: 0, fontSize: '0.7rem', color: 'black', padding: '0.05rem 0.5rem' }}
                    checkedStyle={{ backgroundColor: '#d3a5f9bd' }}
                />
            </div>
        </div>
    );
}

export default ShareLink;
